// src/components/TagItBeacon.jsx
"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { trackPageViewSdk } from "@/lib/tagitSdk";
import { resetFsReads } from "@/lib/fsReads";
import { buildAnalyticsContext } from "@/lib/analyticsContext.mjs";

export default function TagItBeacon({ auto = true, detailsFn, content, surfaceId = "sproutly" } = {}) {
  const pathname = usePathname();
  const search = useSearchParams();
  const lastKeyRef = useRef("");

  useEffect(() => {
    if (!auto) return;
    const eventSubContext = buildAnalyticsContext({ pathname, searchParams: search, surfaceId });
    const key = eventSubContext;
    if (key === lastKeyRef.current) return;
    lastKeyRef.current = key;

    const details = typeof detailsFn === "function" ? detailsFn() : undefined;
    trackPageViewSdk({ path: eventSubContext, details, content });
    resetFsReads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search, auto, detailsFn, content, surfaceId]);

  return null;
}
